import { createAsyncThunk } from '@reduxjs/toolkit';

import { putDataApi } from '../../api/methods';

export const updateAdmin = createAsyncThunk(
    "admin/update",
    (payload: any) => putDataApi({ path: "admin/update", data: payload })
);
